import { render } from "./ObjectivesCard.vue?vue&type=template&id=381c3ae2&scoped=true"
import script from "./ObjectivesCard.vue?vue&type=script&lang=js"
export * from "./ObjectivesCard.vue?vue&type=script&lang=js"

import "./ObjectivesCard.vue?vue&type=style&index=0&id=381c3ae2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-381c3ae2"]])

export default __exports__